// extracted by mini-css-extract-plugin
export default {"price":"jIB_e","discountPercentage":"oNggf"};